// Same-origin relative-path validation for ?redirect= bounce-back.
// Mitigates open-redirect (CWE-601) — only allow paths within this app.
export function isSafeRedirect(target: string | null | undefined): target is string {
  if (!target) return false;
  if (!target.startsWith('/')) return false;
  if (target.startsWith('//')) return false;
  if (target.startsWith('/\\')) return false;
  return true;
}

export function buildSigninUrl(target: string): string {
  return `/signin?redirect=${encodeURIComponent(target)}`;
}
